module.exports = __webpack_public_path__ + "45d494e02118e545d8ed6448a608ae99.png";